module.exports = __webpack_public_path__ + "img/p1.ea70d841.jpg";